<template>
	<div class="fixed bottom-0 right-0 ma-2 mb-16 mr-4 z-10">
		<Toast
			v-for="(item, i) in notifications"
			:key="i"
			class="mb-2"
			:type="item.type"
			:message="$t(item.message)"
			:cta="item.cta"
			closable
			@close="removeMessage(item.message)"
		/>
	</div>
</template>

<script setup lang="ts">
	import { onMounted, onUnmounted, ref } from 'vue'
	import Toast, { ToastCta, ToastType } from '~/components/passporterUi/Toast.vue'
	import EventsService from '~/services/events'
	import Settings from '~/services/settings'

	export type Notification = {
		type: ToastType
		message: string
		cta?: ToastCta
	}
	const notifications = ref<Notification[]>([])

	onMounted(() => {
		EventsService.listenSuccess(handleSuccessNotification)
		EventsService.listenError(handleErrorNotification)
	})

	onUnmounted(() => {
		EventsService.disconnectSuccess()
		EventsService.disconnectError()
	})

	function handleSuccessNotification({ message, cta }: { message: string; cta?: ToastCta }) {
		handleNotification({ message, type: 'success', cta })
	}

	function handleErrorNotification({ message, cta }: { message: string; cta?: ToastCta }) {
		handleNotification({ message, type: 'error', cta })
	}

	function handleNotification(notification: Notification) {
		notifications.value.push(notification)

		setTimeout(() => removeMessage(notification.message), Settings.notificationsTimeToBeHidden())
	}

	function removeMessage(message: string) {
		notifications.value = notifications.value.filter((item) => item.message !== message)
	}
</script>
